import token from './token';
import history from './history';
import { REDIRECT_PATHS, SHOPIFY_AUTH_PATHS, SIGNIN_PATH } from '../constants/pathRedirect';
import { PREVIOUS_LOCATION } from '../constants/localStorageKeys';

const EXCLUDED_PATHS = [SIGNIN_PATH, ...SHOPIFY_AUTH_PATHS];
const isRequiredRedirectPath = (pathname) => {
  return !EXCLUDED_PATHS.includes(pathname) && !REDIRECT_PATHS.some((value) => pathname.includes(value));
};
export const redirectMiddleware = (store) => (next) => (action) => {
  const tokenObj = token.getToken();
  const pathname = history.location.pathname;
  const search = history.location.search;

  if (!tokenObj) {
    if (isRequiredRedirectPath(pathname)) {
      sessionStorage.setItem(PREVIOUS_LOCATION, pathname + search);
      window.location = SIGNIN_PATH;
      return;
    }
  }

  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    window.store = store;
  }

  if (action) {
    next(action);
  }
};
